import { ChiefComplaint } from '../../model/chiefComplaint'
import {
	ExamMedicalReport,
	ExamSurgery,
	Order,
	OtherTest,
	Procedure,
	ScreeningProcedure,
} from '../../model/exam'
import { EdgySections, SnapshotContent } from './slice'

export const checkDataStillPresent = (
	snapshot: SnapshotContent,
	examData?: unknown,
	updatingSection?: EdgySections,
): boolean => {
	if (!Array.isArray(examData)) {
		console.error('examData must be an array')
		return true
	}

	let dataIsPresent = false
	if (snapshot && updatingSection) {
		switch (updatingSection) {
			case 'chiefComplaintCategories': {
				const checkField = (snapshot as ChiefComplaint)?.category
				dataIsPresent = Boolean(
					examData.find(c => (c as ChiefComplaint)?.category === checkField),
				)
				break
			}
			case 'surgeries': {
				const checkField = (snapshot as ExamSurgery)?.id
				const availableSurgery = examData.filter(
					(s: ExamSurgery) => s.status !== 'cancelled',
				)

				dataIsPresent = Boolean(
					availableSurgery.find(s => (s as ExamSurgery)?.id === checkField),
				)
				break
			}
			case 'orders': {
				const checkField = (snapshot as Order)?.id
				const order = examData.find(o => (o as Order)?.id === checkField)
				const availableOrders = examData.filter(
					(o: ExamSurgery) => o.status !== 'cancelled',
				)

				dataIsPresent =
					Boolean(availableOrders.find(o => (o as Order)?.id === checkField)) &&
					order.status === (snapshot as Order).status
				break
			}
			case 'otherTest': {
				const checkField = (snapshot as OtherTest)?.name
				dataIsPresent = Boolean(
					examData.find(ot => (ot as OtherTest)?.name === checkField),
				)
				break
			}
			case 'procedures': {
				const checkField = (snapshot as Procedure)?.code
				dataIsPresent = Boolean(
					examData.find(p => (p as Procedure)?.code === checkField),
				)
				break
			}
			case 'screeningProcedures': {
				const checkField = (snapshot as ScreeningProcedure)?.id
				dataIsPresent = Boolean(
					examData.find(sp => (sp as ScreeningProcedure)?.id === checkField),
				)
				break
			}
			case 'medicalReports': {
				const checkField = (snapshot as ExamMedicalReport)?.id
				dataIsPresent = Boolean(
					examData.find(
						mr =>
							(mr as ExamMedicalReport)?.id === checkField &&
							(mr as ExamMedicalReport)?.status ===
								(snapshot as ExamMedicalReport)?.status,
					),
				)
				break
			}
		}
	}

	return !!dataIsPresent
}
